export default __webpack_public_path__ + "static/media/89.8308ebae.gif";